import { fg } from '@atlassian/jira-feature-gating';
import { globalLayout } from '@atlassian/jira-global-layout/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { csmBaseUrlResource } from '@atlassian/jira-router-resources-service-desk-customer-service-csm-base-url/src/services/index.tsx';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { helpCenterSettingsServiceHubsRoute } from '@atlassian/jira-router-routes-help-center-settings-routes/src/helpCenterSettingsServiceHubsRoute.tsx';
import { helpCenterSettingsServiceHubsRoutePageEntryPoint } from './ui/service-hubs/index.tsx';

export const helpCenterSettingsServiceHubsRouteEntry = createEntry(
	helpCenterSettingsServiceHubsRoute,
	() => ({
		group: 'customer-service',
		perfMetricKey: 'customer-service.service-hubs',
		layout: globalLayout,

		navigation: {
			menuId: MENU_ID.HELP_CENTER_SETTINGS,
		},

		component: ErrorPagesNotFound,

		entryPoint() {
			return fg('jcs_master_flag') ? helpCenterSettingsServiceHubsRoutePageEntryPoint : undefined;
		},

		resources: [...getNavigationResources(), csmBaseUrlResource],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-help-center-settings-entries/src/helpCenterSettingsServiceHubsRouteEntry.tsx',
				whichExportToUse: 'helpCenterSettingsServiceHubsRouteEntry',
			},

			enabled: true,
		},
	}),
);
